module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_vm._v("\n    Proccesing...\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-916fbe26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Payment.vue
// module id = 122
// module chunks = 0